export const ApiResponseCode = {
  Fail: 0, // 失敗 (Only in mock data)
  Success: 1, // 成功

  ParamsError: 1001, // 輸入參數錯誤
  NotCherishFoodTime: 1101, // 非服務時間

  TokenBanned: 2001, // 使用者未經授權

  TokenNotFound: 2100, // 查無憑證
  TokenInvalid: 2101, // 憑證無效
  TokenExpired: 2102, // 憑證已過期
  TokenError: 2199, // 憑證錯誤

  UndefiendError: 9999, // 未明確定義之錯誤
};

/** ErrorCodes is a collection of constants that store all the code represent error */
export const ErrorCodes = [
  ApiResponseCode.ParamsError,
  ApiResponseCode.TokenNotFound,
  ApiResponseCode.TokenInvalid,
  ApiResponseCode.TokenExpired,
  ApiResponseCode.TokenError,
  ApiResponseCode.UndefiendError,
];

export const TokenErrorCodes = []; // not used yet in this project

/** HttpStatus is a collection of constants that store all the http status code */
export const HttpStatus = {
  OK: 200,
  NOT_FOUND: 404,
};

/** Methods is a collection of constants that store all the http methods */
export const Methods = {
  GET: 'GET',
  POST: 'POST',
};

/** CODE_TIMEOUT is a constant that represent the error of api timeout */
export const CODE_TIMEOUT = 'ECONNABORTED';

/** UNKNOWN_ERROR is a constant that represent any unknown error */
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
